export interface URLDescriptorUnaware {
    localizationStrategy: 'none';
}

export interface URLDescriptorLocaleAware {
    localizationStrategy: 'locale';
    isLocalePresent: boolean;
    requestedLocale: string | null;
    desiredLocale: string | null;
}

export interface URLDescriptorLanguageAware {
    localizationStrategy: 'language';
    isLanguagePresent: boolean;
    requestedLocale: string | null;
    desiredLocale: string | null;
    language: string | null;
}

export type URLLocalizationDescriptor = URLDescriptorUnaware | URLDescriptorLocaleAware | URLDescriptorLanguageAware;

// Variations of the first URL segment that look like a language code,
// but are, in fact, valid subroutes
export const languageExceptions = new Set([
    'lp',
    'pr',
]);

// URL segments which must keep "locale" strategy even if the domain is language-aware
export const forceLocaleAwareFor = new Set([
    'inapp',
]);
